import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Status } from '../../services/apiTypes';

interface SelectIdsState {
  categoryId: string;
  typeId: string;
  status: Status;
}

const initialState: SelectIdsState = {
  categoryId: '',
  typeId: '',
  status: 'idle',
};

const selectIdsSlice = createSlice({
  name: 'selectIds',
  initialState,
  reducers: {
    setCategoryId: (state, action: PayloadAction<string>) => {
      state.categoryId = action.payload;
    },
    setTypeId: (state, action: PayloadAction<string>) => {
      state.typeId = action.payload;
    },
    resetSelectIds: (state) => {
      state.categoryId = initialState.categoryId;
      state.typeId = initialState.typeId;
      state.status = initialState.status;
    },
  },
});

export const { setCategoryId, setTypeId, resetSelectIds } =
  selectIdsSlice.actions;

export default selectIdsSlice.reducer;
